import React from 'react';
import Helmet from 'react-helmet';
import Layout from '../../shared/components/Layout/Layout';
import CalendarCreateLayout from './CalendarCreateLayout';

const CalendarCreate = () => (
  <Layout fullWidth>
    <Helmet>
      <title>Create Calendar | TeamBuildr</title>
    </Helmet>
    <CalendarCreateLayout />
  </Layout>
);

CalendarCreate.propTypes = {};
export default CalendarCreate;
